import {
  getLeoUuid,
  LeoUUID,
  getObject,
} from "@surya-digital/leo-ts-types";
import { BoundedName, BoundedNameDTO } from "../types/boundedName";

export interface AllowedDomainDTO {
  domainId: string;
  domainName: BoundedNameDTO;
  domain: BoundedNameDTO;
}

export class AllowedDomain {
  readonly isAllowedDomainAllowedDomain: boolean = true;

  readonly domainId: LeoUUID;
  readonly domainName: BoundedName;
  readonly domain: BoundedName;


  constructor(
  domainId: LeoUUID, 
  domainName: BoundedName, 
  domain: BoundedName
  ) {
    this.domainId = domainId;
    this.domainName = domainName;
    this.domain = domain;
  }

  static fromDTO(dto: AllowedDomainDTO): AllowedDomain {
    const domainId = getLeoUuid(dto, "domainId", InvalidAllowedDomainDomainIdError);
    const domainName = BoundedName.fromDTO(getObject(dto, "domainName", InvalidAllowedDomainDomainNameError));
    const domain = BoundedName.fromDTO(getObject(dto, "domain", InvalidAllowedDomainDomainError));
    return new AllowedDomain(
      domainId,
      domainName,
      domain
    );
  }

  toDTO(): AllowedDomainDTO {
    const dto: AllowedDomainDTO = {
        domainId: this.domainId.toDTO(),
        domainName: this.domainName.toDTO(),
        domain: this.domain.toDTO()
    };
    return dto;
  }
  }

AllowedDomain.prototype.toString = function toString(): string {
  return `AllowedDomain(domainId='${this.domainId}',domainName='${this.domainName}',domain='${this.domain}')`;
};

export class InvalidAllowedDomainError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAllowedDomainError";
  }
}
export class InvalidAllowedDomainDomainIdError extends InvalidAllowedDomainError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAllowedDomainDomainIdError";
  }
}

export class InvalidAllowedDomainDomainNameError extends InvalidAllowedDomainError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAllowedDomainDomainNameError";
  }
}

export class InvalidAllowedDomainDomainError extends InvalidAllowedDomainError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAllowedDomainDomainError";
  }
}
